import { gql } from '@apollo/client';

/**
 * The signed-in user's watchlists.
 *
 * Securities being followed without being held: a scheme shortlisted for a
 * client, a model portfolio being compared before anything is built from it,
 * the stocks a screen just shortlisted. The row carries its own price and
 * day move, so the list is readable without a second call per name.
 *
 * A user keeps several NAMED lists ("small-cap ideas", "retirement core");
 * the default list is "General", which every item lands on when no list is
 * named. `listName` reads one list; without it every list answers, each row
 * saying which list it sits on.
 *
 * `securityType` distinguishes what the symbol IS — the register holds schemes,
 * stocks and portfolios alike, and the same symbol space is not shared between
 * them, so every write names both.
 */
export const GET_USER_WATCHLIST = gql`
  query GetUserWatchlist($language: String, $listName: String) {
    getUserWatchlist(language: $language, listName: $listName) {
      securitySymbol
      securityType
      listName
      name
      currentValue
      previousClose
      return1d
      currency
      exchange
      sector
      upperPriceLimit
      lowerPriceLimit
    }
  }
`;

/** The user's named lists with how many names each holds, the default list first. */
export const GET_USER_WATCHLIST_NAMES = gql`
  query GetUserWatchlistNames {
    getUserWatchlistNames {
      name
      count
    }
  }
`;
